import Pagination from "@/types/Pagination.interface"
import ShortLink from "@/types/ShortLink.interface"

interface State {
    routes: ShortLink[],
}

const defaults = () => {
    return {
        routes: []
    }
}

export default {
    state: defaults(),
    mutations: {
        routesPush (state: State, routes: ShortLink[]): void {
            state.routes = window.removeDuplicatesById(state.routes, routes)
        },
        routesRemove (state: State, ids: number[]): void {
            //  Get our current lists of routes
            const routes = state.routes

            //  If no routes, do nothing
            if (!routes) return

            //  Else, filter out our removed ids
            const filtered = routes.filter((x: ShortLink) => !ids.includes(x.id))

            //  Set our routes to our filtered list
            state.routes = filtered
        },
        routesSet (state: State, routes: ShortLink[]): void {
            state.routes = routes
        },
        routesReset (state: State): void {
            Object.assign (state, defaults())
        }
    },
    actions: {
        routesDelete ({ commit, getters }, routeId: number): Promise<ShortLink> {
            //  Assemble our API endpoint
            const url = `${getters.api}/routes/${routeId}`

            //  Send the request
            return window.axios.delete(url).then(response => {
                //  REmove from our global list
                commit('routesRemove', [routeId])

                //  Remove from our routes view
                commit('routesViewRoutesRmoeve', [routeId])

                //  Remove from our short links list
                commit('messageLinksRemove', [routeId])

                //  REturn the deleted link
                return response.data
            }).catch(() => null)
        },
        routesFind ({ getters }, routeId: number): Promise<ShortLink> {
            //  Assemble the API endpoint
            const url = `${getters.api}/routes/${routeId}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Return our found short link
                return response.data
            }).catch(() => null)
        },
        routesPaginate ({ commit, getters }): Promise<Pagination> {
            //  Create our initial pagination params
            const p = { page: 1 }

            //  Assemble the API endpoint
            const url = `${getters.api}/routes?${window.toUrlParams(p)}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Handle routes module related
                //  Update pagination params
                commit('routesViewPaginationPush', response.data)

                //  Update the routes view routes list
                commit('routesViewRoutesPush', response.data.data)

                //  Update the sh ort links list
                commit('messageLinksPush', response.data.data)

                //  Return the pagination result
                return response.data
            }).catch(() => null)
        },
        routesPost ({ commit, getters }, route: ShortLink): Promise<ShortLink> {
            //  Assemble the API endpoint
            const url = `${getters.api}/routes`

            //  Send the request
            return window.axios.post(url, route).then(response => {
                //  Add it to our lists
                commit('routesPush', [response.data])

                //  Add it to our routes view
                commit('routesViewRoutesPush', [response.data])

                //  Push into message links
                commit('messageLinksPush', [response.data])

                //  Return the newly created short link
                return response.data
            }).catch(() => null)
        },

        // routesSearch ({ commit, getters }, params) {
        //     const url = `${getters.api}/routes/search?${toUrlParams(params)}`
        //     return axios.get(url).then(response => {
        //         commit('routesSet', response.data)
        //         return response.data
        //     }).catch(() => {
        //         return null
        //     })
        // }
    },
    getters: {
        routes (state: State): ShortLink[] {
            return state.routes
        }
    }
}
